import { getEnv } from "./envManager";
import { safeFetch } from "./safe-fetch";

export interface UserTurn {
  index: number;
  preview: string;
  relativeMs: number;
}

export interface ReplayTurn {
  relativeMs: number;
  type: "user" | "assistant";
  userId: string;
  content: string;
  artifacts: Record<string, unknown>;
  userTurnIndex: number;
}

export interface ConversationReplay {
  conversationId: string;
  userTurns: UserTurn[];
  turns: ReplayTurn[];
}

export async function fetchConversationReplay(conversationId: string): Promise<ConversationReplay> {
  const apiBaseUrl = getEnv("API_BASE_URL");
  const response = await safeFetch(`${apiBaseUrl}/dev/replay/${conversationId}`);
  return response.json();
}
